module.exports = __webpack_public_path__ + "img/talk-img3.1007c05c.png";